export default __webpack_public_path__ + "static/media/publicAccount.81026bbe.jpg";